import { productAccessorSomeVariantStockStatusIsAvailable } from '../../model/productAccessor/productAccessorSomeVariantStockStatusIsAvailable'
import { useProductPageContext } from '../productPageContext'

export const useProductAvailableCrossSellWidget = (): boolean => {
  const { followUpProduct, product } = useProductPageContext()

  if (followUpProduct?.canonical_url) {
    return true
  }

  return productAccessorSomeVariantStockStatusIsAvailable(product)
}
